import axios from 'axios'

const API_BASE = buildBase()
const API_URL = API_BASE + '/devapps'
const URL_ALL_FEATURES = API_URL + '/feature/all?authKey=' + process.env.VUE_APP_AUTH_KEY
const URL_ALL_APPLICTION_TYPES = API_URL + '/apptype/all?authKey=' + process.env.VUE_APP_AUTH_KEY
const URL_ALL_WARDS = API_URL + '/ward/all?authKey=' + process.env.VUE_APP_AUTH_KEY
const URL_XL_EXPORT = API_URL + '/ExportData'
//const URL_PARAMS_SEARCH = API_URL + '/as?authKey=' + process.env.VUE_APP_AUTH_KEY
const URL_PARAMS_SEARCH = API_URL + '/search?authKey=' + process.env.VUE_APP_AUTH_KEY
const URL_FORM_IO_URL = process.env.VUE_APP_FORM_IO

// Use the correct API for the current environment.
function buildBase() {
  // First try to get the path from an local environment variable
  var apiPath = process.env.VUE_APP_API_PATH
  if (!apiPath) {
    // Next check if the CI server has injected a path
    apiPath = document.head.querySelector('[name=X_API_SERVER]').content
    if (!apiPath) {
      // Finally use the fallback path
      apiPath = process.env.VUE_APP_DEFAULT_API_PATH
    }
  }
  return apiPath
}

function getGTAG() {
  return process.env.VUE_APP_GTAG;
}

function buildUrl(appStatus, searchText, appType, ward, idx, bounds, orderBy, orderType, lang) {
  let url = URL_PARAMS_SEARCH

  if (appStatus) {
    url = url + '&appStatus=' + appStatus
  }
  if (searchText) {
    url = url + '&searchText=' + searchText
  }
  if (appType) {
    url = url + '&appType=' + appType
  }
  if (ward) {
    url = url + '&ward=' + ward
  }
  if (idx) {
    url = url + '&idx=' + idx
  }
  if (bounds) {
    url = url + '&bounds=' + bounds
  }
  if (orderBy) {
    url = url + '&orderBy=' + orderBy
  }
  if (orderType) {
    url = url + '&orderType=' + orderType
  }
  if (lang) {
    url = url + '&lang=' + lang
  } else {
    url = url + '&lang=en'
  }
  return encodeURI(url)
}

function buildFormIOUrl(curLang, wardInfo, fileLead, applicationNumber, applicationType){
  let formUrl = URL_FORM_IO_URL;

  formUrl = formUrl.replace('[LANG]',curLang)
  formUrl = formUrl.replace('[WARD]',wardInfo)
  formUrl = formUrl.replace('[FILE_LEAD]',fileLead)
  formUrl = formUrl.replace('[APP_NO]',applicationNumber) 
  formUrl = formUrl.replace('[APP_TYPE]',applicationType) 

  return formUrl;
}

async function fetchDevApps(appStatus, searchText, appType, ward, idx, bounds, orderBy, orderType, lang) {
  let data = null
  let url = buildUrl(appStatus, searchText, appType, ward, idx, bounds, orderBy, orderType, lang)
  console.log('fetchDevApps()', 'Fetching ' + url.replace(process.env.VUE_APP_AUTH_KEY, "HIDE"))
  let response = await axios.get(url)
  if (response.status === 200 && response.data) {
    data = response.data
    //console.log('data', data)
    console.log('fetchDevApps()', 'Successfully fetched ' + data.devApps.length + ' records')
  }
  return data
}

async function fetchInitialFeatures() {
  let data = null
  let url = URL_ALL_FEATURES
  console.log('fetchInitialFeatures()', 'Fetching ' + url.replace(process.env.VUE_APP_AUTH_KEY, "HIDE"))
  let response = await axios.get(url)
  if (response.status === 200 && response.data) {
    data = response.data
    console.log('fetchInitialFeatures()', 'Successfully fetched ' + data.length + ' records')
  }
  return data
}

//changed the backend/API to fetch results using Application Number instead of devAppId
async function fetchDevAppById(devAppId) {
  let data = null
  let url = API_URL + '/' + devAppId + '?authKey=' + process.env.VUE_APP_AUTH_KEY
  console.log('fetchDevAppById()', 'Fetching ' + url.replace(process.env.VUE_APP_AUTH_KEY, "HIDE"))
  let response = await axios.get(url)
  if (response.status === 200 && response.data) {
    data = response.data
    console.log('fetchDevAppById()', 'Successfully fetched record with AppNum:' + data.devAppId)
  }
  return data
}

async function fetchApplicationTypes() {
  let data = null
  let url = URL_ALL_APPLICTION_TYPES

  console.log('fetchApplicationTypes()', 'Fetching ' + url.replace(process.env.VUE_APP_AUTH_KEY, "HIDE"))
  let response = await axios.get(url)

  if (response.status === 200 && response.data) {
    data = response.data
    console.log('fetchApplicationTypes()', 'Successfully fetched ' + data.length + ' records')
  } 

  return data;
}

async function fetchWards() {
  let url = URL_ALL_WARDS
  let wards = []

  console.log('fetchWards()', 'Fetching ' + url.replace(process.env.VUE_APP_AUTH_KEY, "HIDE"))
  let response = await axios.get(url)
  if (response.status === 200 && response.data) {
    wards = response.data
    console.log('fetchWards()', 'Successfully fetched ' + wards.length + ' records')
  }
  return wards
}

// We will fetch all geoloactions of DevApps as features
// when applicaiton loads to display points on the map
async function fetchAllFeatures() {
  let data = getEmptyFeatureSet()
  let url = URL_ALL_FEATURES

  console.log('fetchAllFeatures()', 'Fetching ' + url.replace(process.env.VUE_APP_AUTH_KEY, "HIDE"))
  let response = await axios.get(url)
  if (response.status === 200 && response.data) {
    data.features = response.data
    console.log('fetchAllFeatures()', 'Successfully fetched ' + data.features.length + ' records')
  } else {
    data.features.push(getEmptyFeature())
    console.log('fetchAllFeatures()', 'Unable to fetch records')
  }
  return data;
}

function getEmptyFeatureSet() {
  return {
    features: [],
    type: 'FeatureCollection',
  }
}

function getEmptyAddress() {
  return {
    id: '',
    streetAddress: '',
    streetType: ''
  }
}


function getEmptyDevApp() {
  return {
    devAppId: null,
    applicationNumber: null,
    applicationStatus: [],
    devAppAddress: null,
    devAppWard: null,
    applicationType: []  
  }
}

function getEmptyFeature() {
  return {
    properties: {
      devAppId: '',
      applicationNumber: '',
      applicationStatus: '',
      applicationType: '',
      devAppAddress: '',
      devApp: null,
    },
    id: null,
    type: 'Feature',
    geometry: {
      coordinates: [],
      type: 'Point'
    }
  }
}

// WepApi Path for extracting DevApp data in excel format
function buildExcelExportURL() {
  return URL_XL_EXPORT
}

export {
  buildExcelExportURL,
  fetchAllFeatures,
  fetchApplicationTypes,
  fetchWards,
  fetchDevAppById,
  fetchDevApps,
  fetchInitialFeatures,
  getEmptyFeatureSet,
  getEmptyFeature,
  getEmptyDevApp,
  buildFormIOUrl,
  getGTAG,
  getEmptyAddress
}